// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--ngXno","link":"link--+Jp2Q"};